import { render, staticRenderFns } from "./RangesRecommendation.vue?vue&type=template&id=70a7b954&scoped=true"
import script from "./RangesRecommendation.vue?vue&type=script&lang=js"
export * from "./RangesRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7b954",
  null
  
)

export default component.exports